import "@/App.css";
import { BackToTop } from "@/components/BackToTop";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { NavigationBar } from "@/components/sections/NavigationBar";
import { HeroSection } from "@/components/sections/HeroSection";
import { EmotionalTriggers } from "@/components/sections/EmotionalTriggers";
import { AboutSection } from "@/components/sections/AboutSection";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { PricingSection } from "@/components/sections/PricingSection";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { ScarcitySection } from "@/components/sections/ScarcitySection";
import { Footer } from "@/components/sections/Footer";

const LINE_URL = "https://line.me/R/ti/p/@xek1441y";

function App() {
  return (
    <div className="page-shell font-sans text-taupe" data-testid="page-shell">
      <NavigationBar lineUrl={LINE_URL} />
      <main data-testid="main-content">
        <HeroSection lineUrl={LINE_URL} />
        <EmotionalTriggers lineUrl={LINE_URL} />
        <AboutSection />
        <HowItWorks />
        <PricingSection lineUrl={LINE_URL} />
        <TestimonialsSection />
        <ScarcitySection lineUrl={LINE_URL} />
      </main>
      <Footer />
      <BackToTop />
      <StickyMobileCTA lineUrl={LINE_URL} />
    </div>
  );
}

export default App;
